/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: TerritoriesRoutingModule
 * Purpose		: Routing module for Territories.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { TerritoriesListComponent } from './TerritoriesList.component';
import { TerritoriesAddComponent }  from './TerritoriesAdd.component';
import { TerritoriesEditComponent } from './TerritoriesEdit.component';
import { TerritoriesDetailsComponent } from './TerritoriesDetails.component';

const TerritoriesRoutes: Routes = [
	{ path: 'Territories',  component: TerritoriesListComponent },
	{ path: 'Territories/add', component: TerritoriesAddComponent },
	{ path: 'Territories/:id', component: TerritoriesEditComponent },
	{ path: 'Territories/Details/:id', component: TerritoriesDetailsComponent },
];

@NgModule({
  imports: [
    RouterModule.forChild(TerritoriesRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class TerritoriesRoutingModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Territories/Territories-routing.module.ts